import { useEffect, useState } from "react";
import { api, API, trackEvent } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import VideoLibrary from "@/components/site/VideoLibrary";
import WrestlingProfile from "@/components/site/WrestlingProfile";
import Academics from "@/components/site/Academics";
import About from "@/components/site/About";
import Schedule from "@/components/site/Schedule";
import Results from "@/components/site/Results";
import CollegeFit from "@/components/site/CollegeFit";
import ContactSection from "@/components/site/ContactSection";
import MobileCoachCTA from "@/components/site/MobileCoachCTA";
import Footer from "@/components/site/Footer";
import VideoModal from "@/components/site/VideoModal";

export default function RecruitingSite() {
    const [content, setContent] = useState(null);
    const [videoModal, setVideoModal] = useState({ open: false, url: "", title: "" });

    useEffect(() => {
        api.get("/content").then((r) => {
            setContent(r.data);
            const seo = r.data.seo || {};
            document.title = seo.title || "Jai'Rel Young Wrestling Recruit";
            let meta = document.querySelector('meta[name="description"]');
            if (!meta) {
                meta = document.createElement("meta");
                meta.name = "description";
                document.head.appendChild(meta);
            }
            meta.content = seo.description || "";
        });
    }, []);

    const openVideo = (v) => setVideoModal({ open: true, url: v.url, title: v.title });
    const closeVideo = () => setVideoModal({ open: false, url: "", title: "" });

    const downloadResume = () => {
        trackEvent("resume_download");
        window.open(`${API}/resume.pdf`, "_blank");
    };

    const scrollContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

    if (!content) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black">
                <div className="font-mono text-xs tracking-[0.25em] uppercase text-white/50 animate-pulse">
                    Loading recruit file…
                </div>
            </div>
        );
    }

    return (
        <>
            <Nav />
            <Hero
                content={content}
                onPlayFeatured={() => {
                    trackEvent("video_play");
                    openVideo(content.featuredVideo);
                }}
                onContact={scrollContact}
                onDownloadResume={downloadResume}
            />
            <EditorialMarquee content={content} />
            <VideoLibrary content={content} onPlay={openVideo} />
            <WrestlingProfile content={content} />
            <Academics content={content} />
            <About content={content} />
            <Schedule content={content} />
            <Results content={content} />
            <CollegeFit content={content} />
            <ContactSection content={content} />
            <Footer content={content} />
            <MobileCoachCTA />
            <VideoModal open={videoModal.open} onClose={closeVideo} url={videoModal.url} title={videoModal.title} />
        </>
    );
}
